import React from 'react';
import './ExpeditionBadge.css';

export const ExpeditionBadge: React.FC = () => <span className="expedition-badge" role="img" aria-label="Expedition" title="Miskatonic University Expedition">
  <svg viewBox="0 0 32 32" aria-hidden="true"><path d="M16 3 3 27h26L16 3Zm0 9 6 15H10l6-15Z" fill="currentColor" fillRule="evenodd" /><path d="M16 3v24" stroke="currentColor" strokeWidth="2" /></svg>
</span>;
